import counterReducer from '../features/counter/counterSlice';
import createCampaignReducer from '../containers/CreateCampaigns/createCampaignReducer';
import loaderReducer from '../components/Loader/loaderReducer';
import campaignSummaryReducer from '../components/CampaignSummary/campaignSummaryReducer';
import nudgeReducer from '../components/Nudge/nudgeReducer';
import viewCampaignReducer from '../containers/ViewCampaigns/viewCampaignReducer';
import viewSegmentsReducer from '../containers/ViewSegments/viewSegmentsReducer';
import segmentSummaryReducer from '../components/SegmentSummary/segmentSummaryReducer';
import createSegmentsReducer from '../containers/CreateSegments/createSegmentsReducer';
import navBarReducer from '../components/NavBar/navBarReducer';

export default {
    counter: counterReducer,
    createCampaign: createCampaignReducer,
    createSegment: createSegmentsReducer,
    loader: loaderReducer,
    campaignSummary: campaignSummaryReducer,
    segmentSummary: segmentSummaryReducer,
    nudge: nudgeReducer,
    campaignList: viewCampaignReducer,
    segmentList: viewSegmentsReducer,
    navbar: navBarReducer
}